import { Box, Button, Flex, Heading } from '@chakra-ui/react'
import { useRouter } from 'next/router'
import { VscChevronRight } from 'react-icons/vsc'

interface ExternalNavigationButtonProps {
  url: string
  buttonText: string
}

export function ExternalNavigationButton({ url, buttonText }: ExternalNavigationButtonProps) {
  const router = useRouter()
  return (
    <Box>
      <Button variant="txtWhite" onClick={() => router.push(url)}>
        <Flex w="full" align="center" justify="space-between" px={2}>
          <Heading
            as="h2"
            fontWeight="400"
            fontSize={['sm', 'sm', 'md', 'md', 'xl']}
            textTransform="uppercase"
          >
            {buttonText}
          </Heading>
          <Box mr={[-2, -2, -4]} fontSize="2xl">
            <VscChevronRight />
          </Box>
        </Flex>
      </Button>
    </Box>
  )
}
